export const zdfColorsDark: Record<string, string> = {
    // Text
    colorTextPrimary: '#FFFFFF',
    colorTextSecondaryOnBanner: '#969BA2',
    colorTextSecondary: '#969BA2',
    colorTextDisabled: '#969BA2',
    colorTextHint: '#969BA2',
    colorTextAccent: '#FA7D19',
    colorTextWarning: '#DF7C85',
    colorTextSuccess: '#BEE2AD',
    colorTextOnPrimaryButton: '#2D3746',
    colorTextOnAccentColorBg: '#FFFFFF',
    colorTextOnEntryPointColorBg: '#2D3746',
    colorTextOnTagLight: '#0F2335',
    colorTextOnToastDark: '#0F2335',

    // Button
    colorButtonPrimary: '#FA7D19',
    colorButtonAccent: '#FA7D19',
    colorButtonSecondary: '#1D2E3E',
    colorButtonDisabled: '#4D535C',
    colorButtonSliderThumb: '#FFFFFF',

    // Surface
    colorSurfacePrimary: '#0B1D2C',
    colorSurfaceSecondary: '#0F2335',
    colorSurfaceHighlight: '#1C3A56',
    colorSurfaceHighlightShade1: '#3C4F60',
    colorSurfaceHighlightShade2: '#5F6C7B',
    colorSurfaceBannerWarning: '#1D2F3F',
    colorSurfaceBannerSuggestion: '#1C3A56',
    colorSurfaceBannerSuccess: '#1D2F3F',
    colorSurfaceBannerInfo: '#1D2F3F',
    colorSurfaceUserBlock: '#DF7C85',
    colorSurfaceUserWarning: '#FADA82',
    colorSurfaceUserUnblock: '#BEE2AD',
    colorSurfaceUserVerified: '#CCDBE8',
    colorSurfaceToastDark: '#FFFFFF',

    //Tag
    colorTagDefault: '#1D2E3E',
    colorTagAccent: '#FCB175',
    colorTagAccentLight: '#FFD8B9',
    colorTagHighlight: '#DF7C85',
    colorTagWarning: '#FCEBEA',
    colorTagSuccess: '#BEE2AD',
    colorTagVerified: '#CCDBE8',
    colorTagWhite: '#FFFFFF',

    //Border
    colorBorderPrimary: '#969BA2',
    colorBorderPrimaryOnBanner: '#FFFFFF15',
    colorBorderSelected: '#FFFFFF',
    colorBorderAccent: '#FCB175',
    colorBorderAccentLight: '#FFD8B9',
    colorBorderWarning: '#DF7C85',
    colorBorderFacepile: '#969BA2',

    //DataViz
    colorDataVizScale1: '#FA7D19',
    colorDataVizScale2: '#FCB175',
    colorDataVizScale3: '#FFD8B9',
    colorDataVizOther: '#F2F2F2',
    colorDataVizCategory1: '#FA7D19',
    colorDataVizCategory2: '#9DADED',
    colorDataVizCategory3: '#78C7BC',
    colorDataVizCategory4: '#B33737',
    colorDataVizCategory5: '#384877',

    // Entry point colors
    colorEntryPointColorGreen: '#CCDBE8',
    colorEntryPointColorGreenTint: '#1C3A56',
};
